import { useQuery } from '@tanstack/react-query';
import { useApiMutation } from '../../api/mutations';
import { valisightFetch } from './valisightClient';

/**
 * #261 P6 — ValiSight-Log-Erklärungen kuratieren. Läuft über den BFF-Proxy
 * `/proxy/valisight`. Endpoints:
 *   GET  /v1/explanations?state=pending        (Kandidaten)
 *   GET  /v1/explanations?q=&limit=            (bereits erklärt)
 *   POST /v1/explain/:fingerprint              (auto: errorDB → LLM)
 *   POST /v1/explain/:fingerprint/manual       (Operator schreibt selbst)
 *   POST /v1/explain/:fingerprint/dismiss      (Kandidat verwerfen)
 */
const fp = (s) => encodeURIComponent(String(s));

export function useValisightCandidates(limit = 200) {
  return useQuery({
    queryKey: ['vs-candidates', limit],
    queryFn: () => valisightFetch(`/v1/explanations?state=pending&limit=${limit}`),
    refetchInterval: 60_000,
  });
}

export function useValisightExplained(q = '', limit = 100) {
  return useQuery({
    queryKey: ['vs-explained', q, limit],
    queryFn: () => valisightFetch(`/v1/explanations?q=${encodeURIComponent(q)}&limit=${limit}`),
  });
}

export function useAutoExplain() {
  return useApiMutation({
    live: (_fetch, { fingerprint }) =>
      valisightFetch(`/v1/explain/${fp(fingerprint)}`, { method: 'POST' }),
    fixture: ({ fingerprint }) => ({ explanation: { fingerprint, origin: 'errordb' } }),
    invalidate: ['vs-candidates', 'vs-explained'],
    successMessage: () => 'Erklärung erzeugt (errorDB/LLM).',
  });
}

export function useManualExplain() {
  return useApiMutation({
    live: (_fetch, { fingerprint, ...body }) =>
      valisightFetch(`/v1/explain/${fp(fingerprint)}/manual`, {
        method: 'POST', headers: { 'content-type': 'application/json' }, body,
      }),
    fixture: ({ fingerprint }) => ({ explanation: { fingerprint, origin: 'manual' } }),
    invalidate: ['vs-candidates', 'vs-explained'],
    successMessage: () => 'Erklärung gespeichert (manuell).',
  });
}

export function useDismissCandidate() {
  return useApiMutation({
    live: (_fetch, { fingerprint }) =>
      valisightFetch(`/v1/explain/${fp(fingerprint)}/dismiss`, { method: 'POST' }),
    fixture: () => ({ ok: true }),
    invalidate: ['vs-candidates'],
    successMessage: () => 'Kandidat verworfen.',
  });
}
